import { get, put } from "@/api/implementation/app/index.js";

export function getParticularities(clientId) {
  return get(`/client/${clientId}/particularities`);
}

export function saveParticularities(clientId, data) {
  return put(`/client/${clientId}/particularities`, data);
}
